export interface IconRenderProps {
    className?: string | undefined;
    iconType?: 'FontAwesome Icon' | 'Image' | '' | undefined;
    iconName?: string | undefined;
    iconClassName?: string | undefined;
    imageUrl?: string | undefined;
    imageClassName?: string | undefined;
    imageAlt?: string | undefined;
    onClick?: React.MouseEventHandler<HTMLElement>;
    onKeyDown?: React.KeyboardEventHandler<HTMLElement>;
    showSpan?: boolean;
    showButton?: boolean;
    showDiv?: boolean;
    'aria-label'?: string;
    staticDataTabIndex?: number;
}

const IconRender = (props: IconRenderProps) => {
    const {
        className,
        iconType,
        iconName,
        iconClassName,
        imageUrl,
        imageClassName,
        imageAlt,
        onClick,
        onKeyDown,
        showSpan,
        showButton,
        showDiv,
        staticDataTabIndex,
    } = props;

    const Wrapper = showSpan
        ? ({ children }: any) => (
              <span tabIndex={-1} className={className}>
                  {children}
              </span>
          )
        : showButton
          ? ({ children }: any) => (
                <button tabIndex={-1} className={className}>
                    {children}
                </button>
            )
          : showDiv
            ? ({ children }: any) => (
                  <div tabIndex={-1} className={className}>
                      {children}
                  </div>
              )
            : ({ children }: any) => <>{children}</>;

    return (
        <Wrapper>
            {iconType === 'FontAwesome Icon' ? (
                <i
                    className={`${iconClassName} fas ${iconName}`}
                    aria-label={props?.['aria-label'] || ''}
                    onClick={onClick}
                    onKeyDown={onKeyDown}
                    tabIndex={staticDataTabIndex ?? 0}
                />
            ) : iconType === 'Image' ? (
                <img
                    className={imageClassName}
                    src={imageUrl}
                    alt={imageAlt}
                    aria-label={props?.['aria-label'] || ''}
                    onClick={onClick}
                    onKeyDown={onKeyDown}
                    tabIndex={staticDataTabIndex ?? 0}
                />
            ) : null}
        </Wrapper>
    );
};

IconRender.defaultProps = {
    showSpan: false,
    showButton: false,
    showDiv: false,
};

export { IconRender };
